"use client";

import { useRouter } from "next/navigation";

import { ShareIcon } from "../../icons";
import AccessRestriction from "../AccessRestriction";

const ResourceAccessRestriction = () => {
  const router = useRouter();
  return (
    <AccessRestriction
      title="Resource not found"
      description="The resource you are looking for does not exist."
      featureIcon={{ children: <ShareIcon /> }}
      ctaButton={{ children: "Back to home", onClick: () => router.replace("/") }}
    />
  );
};

export default ResourceAccessRestriction;
